"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.amplifyConfig = void 0;
const amplifyconfiguration_json_1 = __importDefault(require("./amplifyconfiguration.json"));
exports.amplifyConfig = amplifyconfiguration_json_1.default;
//# sourceMappingURL=index.js.map